import { createFileRoute, notFound } from "@tanstack/react-router";
import ServicePage, { serviceSlugRedirects } from "@/pages/ServicePage";
import { legacyRedirect } from "@/lib/legacy-redirect";
import { isServiceSlug, serviceHead } from "@/lib/route-seo";
import NotFound from "@/pages/NotFound";

// Legacy slug redirects ported from src/App.tsx
const LEGACY_SLUGS: Record<string, string> = {
  "basketball-court-lighting": "/stadium-sports-lighting/basketball-arena-lighting",
  "park-recreation-lighting": "/stadium-sports-lighting/recreational-park-lighting",
  "arena-lighting": "/stadium-sports-lighting/arena-event-lighting",
};

export const Route = createFileRoute("/stadium-sports-lighting/$slug")({
  beforeLoad: ({ params }) => {
    const target = LEGACY_SLUGS[params.slug];
    if (target) legacyRedirect(target);
    if (!isServiceSlug(params.slug) && !serviceSlugRedirects[params.slug]) throw notFound();
  },
  component: () => <ServicePage basePath="/stadium-sports-lighting" baseLabel="Stadium & Sports Lighting" />,
  notFoundComponent: () => <NotFound hubPath="/stadium-sports-lighting" hubLabel="Stadium & Sports Lighting" />,
  head: ({ params }) => serviceHead("/stadium-sports-lighting", "Stadium & Sports Lighting", params.slug),
});
